import { Collection, RefBool, RefString } from "@tblabs/truffle";
import { RawProductCategory } from "./RawProductCategory";
import { ArticleId } from "../Blog/ArticleId";


export class ProductCategory
{
    public Id = new RefString();
    public Url = new RefString();
    public Title = new RefString();
    public Subtitle = new RefString();
    public Image = new RefString();
    public Description = new RefString();
    public Visible = new RefBool(true);
    public RelatedArticles = new Collection<ArticleId>();

    constructor(raw: Partial<RawProductCategory>)
    {
        this.Id.value = raw.Id || "";
        this.Url.value = raw.Url || "";
        this.Title.value = raw.Title || "";
        this.Subtitle.value = raw.Subtitle || "";
        this.Image.value = raw.Image || "";
        this.Description.value = raw.Description || "";
        this.Visible.value = raw.Visible ?? true;
        this.RelatedArticles.Load(...raw.RelatedArticles || []);
    }

    public static NotFound(): ProductCategory
    {
        return new ProductCategory({ Id: "", Title: "(brak kategorii)" });
    }
}
